import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';

import { Component, Input, OnInit, LOCALE_ID, Inject } from "@angular/core";
import { FormGroup, Validators } from '@angular/forms';
import { IMyOptions } from 'mydatepicker';

import { AppSettings } from "../../shared/app-settings";
import { NofeshService } from "./../nofesh.service"
import { INirsham } from "app/nofesh/model/nirsham";
import { disableDebugTools } from "@angular/platform-browser/src/browser/tools/tools";
import { RequiredValidator } from "@angular/forms/src/directives/validators";
import { DISABLED } from "@angular/forms/src/model";
import { DateService } from 'app/shared/date.service';
import { INofesh } from '../model/nofesh';
import { ActivatedRoute } from '@angular/router';
import { IPrice } from '../model/price';



@Component({
    moduleId: module.id,
    templateUrl: './nirshamim.component.html',
    selector: 'nirshamim'
})
export class NirshamimComponent implements OnInit {

    @Input('group') public nirshamForm: FormGroup;
    @Input() index;
    @Input() nofesh: INofesh;

    minYear: Date = new Date();
    maxYear: Date = new Date();
    darkonMaxYear: Date = new Date();
    darkonMinYear: Date = new Date();
    d: Date = new Date();
    tr_leida_minYear: number = new Date().getFullYear() - 80;
    tr_leida_maxYear: number = new Date().getFullYear() - 16;
    tokef_darkon_minYear: number = new Date().getFullYear();
    tokef_darkon_maxYear: number = new Date().getFullYear() + 20;
    nirshamDetails: INirsham
    is_amit: boolean = false;
    ms_zehut_valid = true;
    set_read_only: boolean = false;
    is_rashum_to_other_nofesh: boolean = false;
    //nofesh: INofesh;
    amitOnly: boolean = false;

    myDatePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
        dayLabels: AppSettings.dayLabels,//{ su: 'א', mo: 'ב', tu: 'ג', we: 'ד', th: 'ה', fr: 'ו', sa: 'ש' },
        monthLabels: AppSettings.monthLabels,// { 1: 'ינו', 2: 'פבר', 3: 'מרץ', 4: 'אפר', 5: 'מאי', 6: 'יוני', 7: 'יולי', 8: 'אוג', 9: 'ספט', 10: 'אוק', 11: 'נוב', 12: 'דצמ' },
        showTodayBtn: false,
        minYear: this.tr_leida_minYear,
        maxYear: this.tr_leida_maxYear,
        firstDayOfWeek: 'su',
        alignSelectorRight: true,
        disableSince: { year: this.tr_leida_maxYear, month: 1, day: 1 },
        disableUntil: { year: this.tr_leida_minYear, month: 1, day: 1 },
    };

    tokefDarkonDatePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
        dayLabels: { su: 'א', mo: 'ב', tu: 'ג', we: 'ד', th: 'ה', fr: 'ו', sa: 'ש' },
        monthLabels: { 1: 'ינו', 2: 'פבר', 3: 'מרץ', 4: 'אפר', 5: 'מאי', 6: 'יוני', 7: 'יולי', 8: 'אוג', 9: 'ספט', 10: 'אוק', 11: 'נוב', 12: 'דצמ' },
        showTodayBtn: false,
        minYear: this.tokef_darkon_minYear,
        maxYear: this.tokef_darkon_maxYear,
        firstDayOfWeek: 'su',
        alignSelectorRight: true,
        disableSince: { year: this.tokef_darkon_maxYear, month: 1, day: 1 },
        disableUntil: { year: this.tokef_darkon_minYear, month: this.d.getMonth() + 1, day: this.d.getDate() }
    };


    constructor(
        private _http: NofeshService,
        private ds: DateService,
        @Inject(LOCALE_ID) public localeId: string,
        public intlService: IntlService,
        private activeRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.localeId = "he-IL";
        (<CldrIntlService>this.intlService).localeId = "he-IL";
        let d = new Date();
        this.maxYear.setFullYear(d.getFullYear() - 16);
        this.minYear.setFullYear(d.getFullYear() - 75);
        this.darkonMinYear.setFullYear(d.getFullYear());
        this.darkonMaxYear.setFullYear(d.getFullYear() + 20);

        if (this.index > 0) // When adding a nilve and nofesh is without zakaut, we will set and disable the checkbox chkllo_nitsul_zakaut by default for nilve (which must be amit)
        {
            // Get nofesh id from query string and fetch the nofesh from storage, then check it's zakaut.
            let nofeshId: number = Number(this.activeRoute.snapshot.params["id"]);
            let nofashim: INofesh[] = JSON.parse(sessionStorage.getItem("nofashim")) as INofesh[];
            this.nofesh = nofashim.find(n => n.id_nofesh == nofeshId);

            if (this.nofesh.no_zakaut_check == 1) {
                // Nofesh without zakaut
                this.setAndDisableZakautCheckbox();
            }
        }

        //debugger
        // TODO: check if statement below when reservation loaded for edit

        /*
        if (this.nirshamForm.get('llo_nitsul_zakaut').value > 0)
        {
            setTimeout( () => {
                var fieldElement = <HTMLInputElement>document.getElementById('chkllo_nitsul_zakaut');
                // console.log(fieldElement);
                fieldElement.disabled = true;
            }, 2000 );
        }
        */

    }

    setAndDisableZakautCheckbox(): void {
        setTimeout(() => {
            this.nirshamForm.patchValue({ llo_nitsul_zakaut: 1 }); // When adding a nirsham (before entering nirsham ms zehut) and nofesh is without zakaut, set value to 1.
            let fieldElement = <HTMLInputElement>document.getElementById('chkllo_nitsul_zakaut');
            fieldElement.disabled = true;
        }, 0);
    }

    getNirshamDetails(ms_zehut) {
        this.amitOnly = false;
        let valid_zehut = this.validatemsZehut(ms_zehut);
        if (valid_zehut) {
            this.ms_zehut_valid = true;
        }
        else {
            this.ms_zehut_valid = false;
            this.nirshamForm.patchValue({ ms_zehut: "" });
            return;
        }

        this._http.getNirshamDetails(ms_zehut)
            .subscribe((nirsham: INirsham) => {

                if (nirsham) {
                    /*
                    UCs   
                    1. zakaut = 1 and is amit
                    +2. zakaut = 1 and is not amit -> error
                    3. zakaut = 0 - open to all

                    */

                    if (this.nofesh.no_zakaut_check == 1 && nirsham.ms_zehut == 0) {
                        // Entered ms_zehut is not amit. Will show error message to user.
                        this.amitOnly = true;
                        return;
                    }

                    // Nofesh uses zakaut
                    if (this.nofesh.no_zakaut_check == 0) {
                        let useZakaut: boolean = this.nirshamForm.get('llo_nitsul_zakaut').value == 0;
                        if (useZakaut && nirsham.ms_zehut > 0 && (nirsham.id_nofesh > 0 || nirsham.zakaut == 0)) {
                            // Amit already registered to a nofesh and used zakaut

                            //check if ichilov and mimushim
                            if (nirsham.amuta_kidum != 1 && nirsham.mimush != 0 && nirsham.mimush != 1)
                                this.is_rashum_to_other_nofesh = true;
                            if (nirsham.amuta_kidum == 1 && nirsham.mimush > 0)
                                this.is_rashum_to_other_nofesh = true;
                            return;
                        }
                    }
                    /*
                    //בדיקת זכאות רק לעובד שמנצל את הזכאות
                    // Is amit and checkbox is not checked
                    if (res.ms_zehut > 0 && this.nirshamForm.get('llo_nitsul_zakaut').value == 0) 
                    {
                        if (res.id_nofesh > 0 || (res.ms_zehut > 0 && res.zakaut == 0)) 
                        {
                            this.is_rashum_to_other_nofesh = true;
                            this.nirshamForm.patchValue({ ms_zehut: "" });
                            return;
                        }
                    }
                    */

                    this.is_rashum_to_other_nofesh = false;
                    this.nirshamDetails = nirsham;
                    console.log(nirsham);
                    this.nirshamForm.patchValue({ shem_prati: this.nirshamDetails.shem_prati });
                    this.nirshamForm.patchValue({ shem_mishpacha: this.nirshamDetails.shem_mishpacha });
                    this.nirshamForm.patchValue({ gender: this.nirshamDetails.gender })
                    if (this.nirshamDetails.tr_leida != null) {
                        let tr_leida = new Date(this.nirshamDetails.tr_leida);
                        this.nirshamForm.patchValue({ tr_leida: tr_leida });
                    }
                    else {
                        this.nirshamForm.patchValue({ tr_leida: '' });
                    }

                    /*
                    if (nirsham.ms_zehut > 0) 
                    {
                        this.set_read_only = true;
                        var fieldElement = <HTMLInputElement>document.getElementById('chkllo_nitsul_zakaut');
                        fieldElement.disabled = true;
                    }
                    else 
                    {
                        this.set_read_only = false;
                        var fieldElement = <HTMLInputElement>document.getElementById('chkllo_nitsul_zakaut');
                        fieldElement.disabled = true; // was false
                    }
                    */
                }
            });
    }

    validatemsZehut(value) {

        if (value.length == 0)
            return false;


        var result = true;
        var first8 = null;
        var cifratBikoret = null;
        try {
            if (value.length == 10)
                first8 = value.substring(0, 9);
            else {
                if (value.length == 9)
                    first8 = "0" + value.substring(0, 8);
                else
                    first8 = "00" + value.substring(0, 8);
            }
            cifratBikoret = value.substring(value.length - 1);
            var checkDigits = 0 * 1;
            var temp = 0;
            var i = 0;

            for (i = 1; i <= 9; i++) {
                temp = first8.charAt(i - 1);
                checkDigits = temp * 1 + checkDigits * 1;
                if ((i % 2) == 1) {
                    checkDigits = temp * 1 + checkDigits * 1;
                    if (temp > 4)
                        checkDigits = checkDigits * 1 - 9;
                }
            }
            checkDigits = (10 - checkDigits % 10) % 10;
            result = (checkDigits * 1 == cifratBikoret * 1);
        }
        catch (e) { result = false; }
        if (value == "0")
            result = false;
        return result;
    }
}
